import { jsx as r } from "react/jsx-runtime";
import a from "classnames";
import d from "../../utils/colors.js";
import { b as f } from "../../styled-qu50FBLM.mjs";
import { Svg as h, GElement as t, Line as p } from "./Elements.js";
const b = ({
  className: o = "",
  fill: i = d.logoOrange,
  width: n = 21,
  height: l = 45,
  viewBox: s = "0 0 21 45",
  $cssHelper: m = f,
  focusable: e
}) => /* @__PURE__ */ r(
  h,
  {
    className: a({ [o]: !!o }),
    viewBox: s,
    width: `${n}px`,
    height: `${l}px`,
    $cssHelper: m,
    focusable: !!e,
    "aria-hidden": !e,
    children: /* @__PURE__ */ r(t, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(t, { transform: "translate(-248.000000, -10.000000)", stroke: i, children: /* @__PURE__ */ r(p, { x1: "248.675007", y1: "54.2903847", x2: "268.254517", y2: "10" }) }) })
  }
);
export {
  b as default
};
